var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUmbrella(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_132476",
    "data-name": "Group 132476",
    transform: "translate(-386.714 -442.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g405",
    transform: "translate(386.714 442.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path407",
    d: "M32.244-210.374a1.019,1.019,0,0,1-.723-.3,10.218,10.218,0,0,0-7.271-3.011,10.218,10.218,0,0,0-7.273,3.012,1.02,1.02,0,0,1-.721.3,1.019,1.019,0,0,1-.723-.3,10.218,10.218,0,0,0-7.271-3.011A10.217,10.217,0,0,0,1-210.678a1.02,1.02,0,0,1-.726.3A1.019,1.019,0,0,1-.75-211.393a24.876,24.876,0,0,1,1.9-9.567,24.877,24.877,0,0,1,5.419-8.111,24.876,24.876,0,0,1,8.11-5.419,24.876,24.876,0,0,1,9.567-1.9,24.878,24.878,0,0,1,9.568,1.9,24.875,24.875,0,0,1,8.11,5.419,24.876,24.876,0,0,1,5.419,8.111,24.876,24.876,0,0,1,1.9,9.567,1.019,1.019,0,0,1-.641.947,1.019,1.019,0,0,1-1.1-.227,10.218,10.218,0,0,0-7.271-3.011,10.218,10.218,0,0,0-7.272,3.012A1.016,1.016,0,0,1,32.244-210.374Zm-23.981-5.35a12.232,12.232,0,0,1,7.994,2.943,12.232,12.232,0,0,1,7.994-2.943,12.232,12.232,0,0,1,7.994,2.943,12.232,12.232,0,0,1,7.994-2.943,12.236,12.236,0,0,1,6.867,2.086,22.789,22.789,0,0,0-6.618-13.992,22.811,22.811,0,0,0-16.236-6.725A22.811,22.811,0,0,0,8.014-227.63,22.79,22.79,0,0,0,1.4-213.638,12.238,12.238,0,0,1,8.263-215.724Z",
    transform: "translate(0.75 236.393)",
    fill: "#09143a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g409",
    transform: "translate(397.596 463.381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path411",
    d: "M-121.724,28.539a7.568,7.568,0,0,1-7.559-7.559,1.019,1.019,0,0,1,1.019-1.019,1.019,1.019,0,0,1,1.019,1.019,5.527,5.527,0,0,0,5.521,5.521,5.485,5.485,0,0,0,3.9-1.617,5.485,5.485,0,0,0,1.617-3.9V.269A1.019,1.019,0,0,1-115.183-.75,1.019,1.019,0,0,1-114.164.269V20.98a7.51,7.51,0,0,1-2.214,5.345A7.51,7.51,0,0,1-121.724,28.539Z",
    transform: "translate(129.283 0.75)",
    fill: "#09143a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella);
export default __webpack_public_path__ + "static/media/umbrella.60d968a52ba11371804307614b91c732.svg";
export { ForwardRef as ReactComponent };